import { EBuildingGatesType } from '../../../../json_query';
import { changeBuildingGates } from '../../../state/advanced/building_gates';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const BuildingGates = getMultiSelectParam<EBuildingGatesType>(
  'Ворота',
  [
    { title: 'На пандусе', value: EBuildingGatesType.Ramp },
    { title: 'Докового типа', value: EBuildingGatesType.Dock },
    { title: 'На нулевой отметке', value: EBuildingGatesType.Ground },
  ],
  'building_gates_type',
  changeBuildingGates,
);
